import { render } from "./SwapLayerComponent.vue?vue&type=template&id=52eb0757&scoped=true"
import script from "./SwapLayerComponent.vue?vue&type=script&lang=js"
export * from "./SwapLayerComponent.vue?vue&type=script&lang=js"

import "./SwapLayerComponent.vue?vue&type=style&index=0&id=52eb0757&scoped=true&lang=css"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eb0757"]])

export default __exports__